import { BaseSetting, TemsWebSetting } from "@/Settings/SettingsManager";
import { SiteState, MaintenanceViewState } from "@/TemsManagerWebEnums";
import ManagerView from "@/ManagerView";
import TemsWebEvents from "@/TemsWebEvents";
import Localization from "@/Localization";
import { SiteViewModel, InfoViewModel, MaintenanceStateViewModel } from "@/TemsManagerWebInterface";
import "bootstrap";
import _ from "lodash";
import TemsPolicy, { UserLevelToPolicyConverter, ViewModelUserLevel } from "Tems/Security/TemsPolicy";


class GlobalViewSettings extends BaseSetting {
    public expertMode: boolean = false;
}

export default class LayoutManagerView extends ManagerView {

    public static GlobalSettings = new TemsWebSetting<GlobalViewSettings>("GlobalSettings", new GlobalViewSettings());
    private isSiteStateError = false;

    private maintenanceWatcherTimeoutHandle: number;
    private maintenanceWatcherUpdateInterval = 2000;
    private maintenanceStartTime: Date;
    private maintenanceReloadTime: Date = null;
    private maintenanceEstimatedExecutionTime: number = 0;

    protected desiredStates: SiteState[];

    public SiteStateModes: {};

    private currentSiteState: SiteState = undefined;

    private get CurrentSiteState() {
        return this.currentSiteState;
    }

    private set CurrentSiteState(newSiteState: SiteState) {
        const stateChanging = this.currentSiteState !== newSiteState;
        this.currentSiteState = newSiteState;
        if (stateChanging) {
            TemsWebEvents.publishEvent(TemsWebEvents.SiteStateChanged, [newSiteState]);
        }
    }

    handleDocumentReady() {
        TemsWebEvents.subscribeEvent(TemsWebEvents.SiteStateChanged, (evt, newSiteState) => { this.handleSiteStateChange(newSiteState); });
        TemsWebEvents.subscribeEvent(TemsWebEvents.UserLevelChanged, (evt) => {
            this.updateNavigation(this.CurrentSiteState);
        });

        let fnEditable = $.fn.editable as any;
        if (fnEditable) {
            fnEditable.defaults.mode = 'popup';
            fnEditable.defaults.onblur = 'submit';
            fnEditable.defaults.escape = true;
            fnEditable.defaults.clear = false;
            fnEditable.defaults.showbuttons = false;
            fnEditable.defaults.emptytext = Localization.resourceStrings.SiteView_EditableEmptyText;
        }

        var that = this;
       
        $("#buttonMaintenanceFinish").click(() => {
            this.changeUserLevel(ViewModelUserLevel.Service).then(() => {
                $("#formMaintenanceFinish").submit();
            });
        });

        $("#formMaintenanceFinish").on("submit", (event) => {
            event.preventDefault();

            // Disable the "finish"-button since the dialog is only removed when the InfoViewModel.MaintenanceId is set to NULL by the next update
            $("#buttonMaintenanceFinish").toggleClass("disabled", true);
            $("#idMaintenanceFinishSpinner").toggleClass("hidden", false);

            $.ajax({
                url: $(event.currentTarget).attr("action"),
                data: {
                    "id": event.currentTarget["idMaintenanceFinish"].value
                },
                type: 'POST',
            }).done(() => {
                this.forceSiteModelUpdate();
            });
        });

        $("#buttonModalStopSite").click(() => {
            this.stopSite();
        });

        $("#buttonModalSetupNoAccessClose").click(() => location.href = "/Home/Site");

        // Navbar userBrand Menu
        $("#buttonResetSiteSettings").click(() => {
            localStorage.clear();
            location.reload();
        });

        $("#buttonChangeUserLevel").click(() => {
            this.authorizationView.showLogin();
        });

        $("#buttonLogOff").click(() => {
            if (this.authorization.authorize(TemsPolicy.OperatorPolicy)) {
                this.gateway.get("Disconnect", {}, [TemsPolicy.OperatorPolicy]);
                this.authorization.logout();
                location.reload();
            }
           
            return false;
        });

        $("#buttonNotAuthenticated").click(() => this.changeUserLevel(ViewModelUserLevel.Operator).then(() => location.reload()));
        $("#buttonLogin").click(() => this.changeUserLevel(ViewModelUserLevel.Operator).then(() => location.reload()));


        $("#buttonModalConnectionErrorReload").click(() => location.reload());
        $("#buttonModalCloseChangeState").click(() => this.hideProcessingModal());

        $(document).on("shown.bs.modal", ".modal", (event) => {
            var zIndex: number = Math.max.apply(null, $('*:not(.modal-backdrop)').map((index, elem) => {
                var curZIndex = Number($(elem).css("z-index"));
                return curZIndex > 0 && curZIndex <= 65535 ? curZIndex : 0;
            }).toArray()) + 30;

            $(event.currentTarget).css("z-index", zIndex);
            $(".modal-backdrop").css("z-index", zIndex - 1);
        });

        $(document).on("hidden.bs.modal", ".modal", (event) => {
            $(event.currentTarget).css("z-index", 0);
            var zIndex: number = Math.max.apply(null, $('*:not(.modal-backdrop)').map((index, elem) => {
                var curZIndex = Number($(elem).css("z-index"));
                return curZIndex > 0 && curZIndex <= 65535 ? curZIndex : 0;
            }).toArray());

            $(".modal-backdrop").css("z-index", zIndex - 1);
        });
        

        // check if returnUrl is set and open UserLevel Dialog with needed Level
        if (this.returnUrl) {
            var returnUrl = this.returnUrl;
            this.changeUserLevel(ViewModelUserLevel.Service).then(() => {
                location.href = returnUrl;
            });
        }
    }

    handleSiteUpdate(model: InfoViewModel) {
        $("#navbar .resultView").remove();

        if (model.Site && model.Site.ResultViews) {
            // Show menu items for the result views
            $("#dropdownSetupMenu").before(
                $(model.Site.ResultViews.map((r) => {
                    var li = document.createElement("li");
                    li.setAttribute("class", "resultView");

                    var a = document.createElement("a");
                    a.setAttribute("href", "/Home/ResultList?viewId=" + r.Id);
                    a.text = r.Title;
                    li.appendChild(a);

                    return li;
                }))
            );
        }

        // Determine UserLevel
        if (model && model.RecorderState) {
            this.CurrentSiteState = model.RecorderState.SiteState;
        } 

        if (model) {

            // Error messages from TEMS Recorder
            if (model.ConnectionErrorMessage) {
                // Show error message
                $("#modalConnectionError > .modal-dialog > .modal-content > .modal-body").text(model.ConnectionErrorMessage);
                if (!$("#modalConnectionError").hasClass("in")) {
                    $("#modalConnectionError").modal("show");
                }
            } else {
                // Hide error message
                if ($("#modalConnectionError").hasClass("in")) {
                    $("#modalConnectionError").modal("hide");
                }

                // Enable / disable the maintenance watcher depending on whether a maintenance operation is running or not
                if (model.MaintenanceId !== null && this.returnUrl === null) {
                    this.startMaintenanceWatcher();
                } else {
                    this.stopMaintenanceWatcher();
                }
            }

            // Update footer information
            $("#recorderProduct").text(model.Recorder.Product);
            $("#recorderSerial").text(model.Recorder.SerialNumber);
            $("#recorderVersion").text(this.getReducedVersion(model.Recorder.Version));
            $("#divStateAndRecorder").show();

            // Update menu entries
            $("#dropdownLinkSetupAdjustClock").toggle(model.Recorder.CanAdjustComputerClock);
            $("#dropdownLinkSetupIpConfigurationExternal").toggle(model.Recorder.CanChangeIpConfigurationExternal);
            $("#dropdownLinkSetupIpConfigurationDevices").toggle(model.Recorder.CanChangeIpConfigurationDevices && model.Recorder.DeviceNetworkInterfaces.length > 0);
            $("#dropdownLinkSetupNtpConfiguration").toggle(model.Recorder.CanChangeNtpConfiguration);
            $("#dropdownLinkSetupFirmwareUpdate").toggle(model.Recorder.CanInstallFirmwareUpdates);
            $("#dropdownLinkSetupCertificateUpdate").toggle(model.Recorder.CanChangeCertificate);
            $("#dropdownLinkSetupNtpConfiguration").toggle(model.Recorder.CanObserveNtpClient);
            $("#dropdownLinkSetupChangeSerialNumber").toggle(model.Recorder.CanChangeSerialNumber);

            $("#dropdownLinkSetupTopElement").toggleClass("navbarSiteHasWarning", model.HasPackageLoadError);
            $("#dropdownLinkSetupPackages > a").toggleClass("navbarSiteHasWarning", model.HasPackageLoadError);
        } else {
            $("#divStateAndRecorder").hide();
        }
    }

    handleSiteUpdateError(errorMessage: string) {
        super.handleSiteUpdateError(errorMessage);

        // Show error message
        $("#modalConnectionError > .modal-dialog > .modal-content > .modal-body").text(errorMessage);
        if (!$("#modalConnectionError").hasClass("in")) {
            $("#modalConnectionError").modal("show");
        }
    }

    handleSiteNoTranslations(): void {
        super.handleSiteNoTranslations();

        $("#modalTranslationsFailed").modal("show");
    }

    protected handleSiteStateChange(newSiteState: SiteState): void {
        this.isSiteStateError =
            newSiteState === SiteState.SensorDiscoveryFailure ||
            newSiteState === SiteState.SensorUpdateFailure ||
            newSiteState === SiteState.ConfigurationInitializationFailure ||
            newSiteState === SiteState.ConfigurationRunningError ||
            newSiteState === SiteState.ConfigurationFinalizationFailure;

        // Show modal dialog about state changes
        if (this.desiredStates === undefined || this.desiredStates.indexOf(newSiteState) >= 0) {
            if ($("#modalChangeState").hasClass("in")) {
                this.hideProcessingModal();
            }
        } else if (this.isSiteStateError) {
            $("#buttonModalCloseChangeState").show();
            $("#modalChangeState > .modal-dialog > .modal-content > .modal-header > .modal-title").addClass("alert alert-danger");
            $("#modalChangeState > .modal-dialog > .modal-content > .modal-header > .modal-title").html(this.SiteStateModes[newSiteState]);
            $("#modalChangeState > .modal-dialog > .modal-content > .modal-body > .progress > .progress-bar").addClass("progress-bar-danger");
            $("#modalChangeState > .modal-dialog > .modal-content > .modal-body > .progress > .progress-bar").html("<span>" + this.SiteStateModes[newSiteState] + "</span>");
        }

        if (newSiteState === SiteState.ConfigurationRunning) {
            $(".showAllChildDevices").removeClass("showAllChildDevices");
        }

        this.updateNavigation(newSiteState);

        // Show state in menu bar
        $(".stateSiteState").text(this.SiteStateModes[newSiteState]);
        $("#stateSiteState").toggleClass("navbarSiteHasWarning", this.isSiteStateError);
        $("#linkSiteNavbar").toggleClass("navbarSiteHasWarning", this.isSiteStateError);
    }

    public showAcknowledgementModal(textBody: string, textTitle: string, button1?: CustomButton, button2?: CustomButton, button3?: CustomButton, alert?: boolean): void {
        if (alert === undefined) {
            alert = false;
        }

        if (button1 === undefined) {
            button1 = CustomButton.Create();
        }

        if (button2 === undefined) {
            button2 = CustomButton.Create();
        }

        if (button3 === undefined) {
            button3 = CustomButton.Create(
                Localization.resourceStrings.LayoutView_ButtonCancel,
                () => { this.hideAcknowledgementModal(); },
                true);
        }

        if (textBody === undefined) {
            textBody = "";
        }

        if (textTitle === undefined) {
            textTitle = "";
        }

        var elemAcknowledge = $("#modalAcknowledge");
        elemAcknowledge.on("shown.bs.modal", () => { });
        alert ? elemAcknowledge.find(".modal-content").addClass("alert alert-danger") : elemAcknowledge.find(".modal-content").removeClass("alert alert-danger");

        CustomButton.ConfigureJQueryElement(elemAcknowledge.find("#button1ModalAcknowledge"), button1);
        CustomButton.ConfigureJQueryElement(elemAcknowledge.find("#button2ModalAcknowledge"), button2);
        CustomButton.ConfigureJQueryElement(elemAcknowledge.find("#button3ModalAcknowledge"), button3);

        elemAcknowledge.find(".modal-title").html(textTitle);
        elemAcknowledge.find(".modal-body").html(textBody);

        elemAcknowledge.modal(ManagerView.MODAL_SHOW_BACKDROP);
    }

    public hideAcknowledgementModal(): void {
        $("#modalAcknowledge").modal("hide");
    }

    public showProcessingModal(desiredStates: SiteState[], title: string, body = "", closeButton?: CustomButton): Promise<void> {
        this.desiredStates = desiredStates;
        if (closeButton === undefined) {
            closeButton = CustomButton.Create(Localization.resourceStrings.LayoutView_ModalChangeStateButtonClose, () => { this.hideProcessingModal(); }, true);
        }

        var doneResolver;
        var donePromise = new Promise<void>((resolve, _) => doneResolver = resolve);
        CustomButton.ConfigureJQueryElement($("#buttonModalCloseChangeState"), closeButton);
        $("#modalChangeState > .modal-dialog > .modal-content > .modal-header > .modal-title").text(title);
        $("#modalChangeState > .modal-dialog > .modal-content > .modal-header > .modal-title").removeClass("alert alert-danger");
        $("#modalChangeState > .modal-dialog > .modal-content > .modal-body > .progress > .progress-bar").html("<span>" + body + "</span>");
        $("#modalChangeState").data("doneHandler", doneResolver).modal(ManagerView.MODAL_SHOW_NO_BACKDROP);
        return donePromise;
    }

    public hideProcessingModal(): void {
        this.desiredStates = undefined;
        $("#buttonModalCloseChangeState").hide();
        $("#modalChangeState > .modal-dialog > .modal-content > .modal-header > .modal-title").removeClass("alert alert-danger");
        $("#modalChangeState > .modal-dialog > .modal-content > .modal-body > .progress > .progress-bar").removeClass("progress-bar-danger");
        var modal = $("#modalChangeState").modal("hide");
        var handler = modal.data("doneHandler");
        if (handler) {
            handler();
            modal.removeData("doneHandler");
        }
    }

    /// <deprecated> Use Authorization to Assert Userlevel
    public async changeUserLevel(minUserLevel: ViewModelUserLevel, modalHeader?: string) {
        return this.authorizationView.getTokenForPolicy(UserLevelToPolicyConverter(minUserLevel));
    }

    private getReducedVersion(version: string): string {
        if (version) {
            var versionParts = version.split(".", 3);
            versionParts.pop();
            return versionParts.join(".");
        } else {
            return "";
        }
    }

    private updateNavigation(siteState: SiteState) {
        var currentUser = this.authorization.getCurrentUser();
        var userLabel = Localization.resourceStrings.Navigation_LabelUser;
        $(".stateUserName").text(userLabel + ": " + currentUser.UserName);

        // Check if setup is accessible in current state
        var setupNavigationLinks = $(".setupNavigation");
        var setupNavigationStoppedConfigLinks = setupNavigationLinks.not(".accessWhileRunning");

        $("#dropdownSetupMenu").toggleClass("disabled", !this.authorization.authorize(TemsPolicy.ServicePolicy));
        setupNavigationLinks.parent("li").toggleClass("disabled", !this.authorization.authorize(TemsPolicy.ServicePolicy));
        setupNavigationLinks.unbind("click");
        setupNavigationLinks.on("click", (event) => {
            event.preventDefault();
            var destination = $(event.currentTarget).attr("href");
            this.changeUserLevel(ViewModelUserLevel.Service).then(() => {
                location.href = destination;
            });
        });

        var isAnySetupLinkEnabled = setupNavigationLinks.parent("li").siblings().not(".disabled").length > 0;
        $("#dropdownSetupMenu").toggleClass("disabled", !isAnySetupLinkEnabled);

        $("#dropdownLinkSetupDeleteLogsAndData").toggle(this.authorization.authorize(TemsPolicy.ProductionPolicy));

        if (siteState !== SiteState.NotConfigured) {
            setupNavigationStoppedConfigLinks.parent("li").toggleClass("disabled", true);
            setupNavigationStoppedConfigLinks.unbind("click");
            setupNavigationStoppedConfigLinks.click((event) => {
                event.preventDefault();
                this.showSetupNotAccessible().then(() => {
                    window.location.href = $(event.target).attr("href");
                });
                return false;
            });
            setupNavigationStoppedConfigLinks.on("click", (event) => {
                event.preventDefault();
            });
        }
    }

    protected clearModalLoginValues() {
        $("#inputHiddenUserLevel").val("");
        $("#inputUserLevelPassword").val("");
        $("#inputLoginOverrideConnectionLimit").hide();
    }


    public static ShowAlertMessage(title: string, statusMessage: string, statusTemplate = "{0}") {
        $("#labelModalAlert").text(title);
        $("#modalAlert > .modal-dialog > .modal-content > .modal-body").text(statusTemplate.replace("{0}", statusMessage));
        $("#modalAlert").modal(ManagerView.MODAL_SHOW_BACKDROP);
    }

    public showAlertMessage(title: string, statusMessage: string, statusTemplate = "{0}") {
        LayoutManagerView.ShowAlertMessage(title, statusMessage, statusTemplate);
    }

    protected convertToLocalNumber(value, fractionDigits, styleDefinition) {
        var number = Number(value);
        return isNaN(number) ?
            "--" :
            number.toLocaleString(
                Localization.Culture,
                {
                    minimumFractionDigits: fractionDigits,
                    maximumFractionDigits: fractionDigits,
                    style: styleDefinition
                });
    }

    /// Promise with a boolean wether the conifigurationWasStopped
    protected showSetupNotAccessible() : Promise <boolean> {
        return new Promise((resolve, reject) => {
            var modal = $("#modalSetupNotAccessible")
                .data("onStopped", resolve)
                .data("onStartStop", () => { modal.modal("hide"); })
                .data("onAbort", reject)
                .modal("show");
        });
    }

    protected stopSite() : Promise<void> {
        var modal = $("#modalSetupNotAccessible");
        var result = this.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            return new Promise<void>((resolve, reject) => {
                $.ajax({
                    url: "/api/SiteEdit/SiteStop",
                    method: 'POST'
                }).done(() => {
                    executeDataIfExists("onStartStop")(null);

                    this.showProcessingModal([SiteState.NotConfigured],
                        Localization.resourceStrings.LayoutView_ModalChangeStateConfigurationStopping,
                        Localization.resourceStrings.LayoutView_ModalChangeStateConfigurationStopping
                    ).then(resolve).catch(reject);
                }).fail(reject);
            });
        });
        
        result.then(executeDataIfExists("onStopped", "onAbort"));
        result.catch(executeDataIfExists("onAbort", "onStopped"));
        return result;

        function executeDataIfExists(key: string, otherKeyToDelete?: string) {
            return (_) => {
                var callback = modal.data(key);
                if (callback) {
                    callback();
                    modal.removeData(key);
                    if (otherKeyToDelete) {
                        modal.removeData(otherKeyToDelete);
                    }
                }
            }
        }
    }

    /**
     * Called by LayoutManagerView when a setup operation is over. It is called no matter what the outcome of the operation was.
     */
    protected handleStopMaintenance(): void {
    }

    protected startMaintenanceWatcher(): void {
        if (!this.isMaintenanceWatcherRunning) {
            this.isMaintenanceWatcherRunning = true;
            this.maintenanceStartTime = new Date();
            this.runMaintenanceWatcher();
        }
    }

    private stopMaintenanceWatcher() {
        if (this.isMaintenanceWatcherRunning) {
            this.isMaintenanceWatcherRunning = false;
            window.clearTimeout(this.maintenanceWatcherTimeoutHandle);

            // Hide modal maintenance dialog box
            this.showMaintenanceState(null);

            this.handleStopMaintenance();
        }
    }

    private runMaintenanceWatcher() {
        $.getJSON("/api/Maintenance/GetMaintenanceState")
            .done((maintenanceState: MaintenanceStateViewModel) => {
                if (maintenanceState) {
                    this.maintenanceEstimatedExecutionTime = maintenanceState.EstimatedExecutionTime;
                    this.maintenanceReloadTime = new Date(Date.now() + maintenanceState.WaitTimeBeforeReload);
                    this.showMaintenanceState(maintenanceState);
                } else {
                    // According to TEMS Recorder no maintenance operation is running -> stop watcher
                    this.stopMaintenanceWatcher();
                }
            }).fail((jqXHR, textStatus, errorThrown) => {
                if (jqXHR.status === 401) {
                    // The web server was restarted, our user credentials were lost -> Reload the page to re-login
                    if (Date.now() > this.maintenanceReloadTime.valueOf()) {
                        this.stopMaintenanceWatcher();
                        location.reload();
                    } else {
                        this.showMaintenanceProgressBar(true, false);
                    }
                } else {
                    // The web server is currently not running which is "normal" during a maintenance operation. We just wait for it to come back.
                    this.showMaintenanceProgressBar(true, false);
                }
            }).always(() => {
                // When the watcher was not stopped yet, we start a new update cycle
                if (this.isMaintenanceWatcherRunning) {
                    this.maintenanceWatcherTimeoutHandle = window.setTimeout(() => this.runMaintenanceWatcher(), this.maintenanceWatcherUpdateInterval);
                }
            });
    }

    private showMaintenanceState(maintenanceInfo: MaintenanceStateViewModel) {
        var modal = $("#modalMaintenanceMessage");
        if (maintenanceInfo) {
            modal.find("#labelMaintenanceTitle").text(maintenanceInfo.Title);
            if (maintenanceInfo.State === MaintenanceViewState.Executed) {
                $("#idMaintenanceFinish").val(maintenanceInfo.Id);
                if (maintenanceInfo.ErrorMessage) {
                    modal.find("#descriptionProgress").text(Localization.resourceStrings.LayoutView_MaintenanceExecutionFailure + " " + maintenanceInfo.ErrorMessage);
                    this.showMaintenanceProgressBar(false, true);
                } else {
                    modal.find("#descriptionProgress").text(Localization.resourceStrings.LayoutView_MaintenanceExecutionSuccess);
                    this.showMaintenanceProgressBar(false, false);
                }
                $("#buttonMaintenanceFinish").show();
            } else {
                modal.find("#descriptionProgress").text(Localization.resourceStrings.LayoutView_MaintenanceExecuting);
                $("#buttonMaintenanceFinish").hide();
                this.showMaintenanceProgressBar(true, false);
            }

            if (!modal.hasClass("in") && maintenanceInfo.State !== MaintenanceViewState.Loaded) {
                $("#buttonMaintenanceFinish").toggleClass("disabled", false);
                $("#idMaintenanceFinishSpinner").toggleClass("hidden", true);

                modal.modal(ManagerView.MODAL_SHOW_NO_BACKDROP);
            }
        } else {
            if (modal.hasClass("in")) {
                modal.modal("hide");
                this.resetMaintenanceProgress();
            }
        }
    }

    private showMaintenanceProgressBar(isExecuting: boolean, hasError: boolean) {
        let value = 0;
        if (isExecuting) {
            let passedTime = Date.now() - this.maintenanceStartTime.valueOf();
            if (passedTime < this.maintenanceEstimatedExecutionTime) {
                value = Math.round(100 * (passedTime / this.maintenanceEstimatedExecutionTime));
            } else if (this.maintenanceEstimatedExecutionTime > 0) {
                value = 100;
            }
        } else {
            value = 100;
        }

        $("#progressMaintenance").toggleClass("progress-bar-success", !isExecuting && !hasError);
        $("#progressMaintenance").toggleClass("progress-bar-danger", !isExecuting && hasError);
        $("#progressMaintenance").attr('aria-valuenow', value);
        $("#progressMaintenance").css('width', value + "%");
        $("#progressMaintenance").text(value + "%");
    }

    private resetMaintenanceProgress() {
        $("#progressMaintenance").removeClass("progress-bar-success");
        $("#progressMaintenance").removeClass("progress-bar-danger");
        $("#progressMaintenance").attr('aria-valuenow', 0);
        $("#progressMaintenance").css('width', "0%");
        $("#progressMaintenance").css('min-width', "2em");
        $("#progressMaintenance").text(" ");
    }
   
    private checkForSufficientLevel(minLevel: ViewModelUserLevel, currentLevel: ViewModelUserLevel) {
        return currentLevel >= minLevel;
    }
}

export class CustomButton {
    public Text = "";
    public ClickHandler = () => { };
    public Visible = false;

    static Create(text?: string, clickHandler?: () => void, visible?: boolean): CustomButton {
        var button = new CustomButton();
        if (text !== undefined) {
            button.Text = text;
        }

        if (clickHandler !== undefined) {
            button.ClickHandler = clickHandler;
        }

        if (visible !== undefined) {
            button.Visible = visible;
        }

        return button;
    }

    static ConfigureJQueryElement(domButton: JQuery, definition: CustomButton): void {
        if (definition.Visible) {
            domButton.show();
            domButton.html(definition.Text);
            domButton.unbind("click");
            domButton.on("click", definition.ClickHandler);
        } else {
            domButton.hide();
        }
    }
}
